
import FastImage from "../../../globals/elements/fastimg"
import { publicUrlFor } from "../../../globals/constants"
export default function ContactForm1({
    options,
    data 
}){
    return (
        <div className="section-full bg-white bg-right-center bg-no-repeat" style={{ backgroundImage: `url(${publicUrlFor("images/background/bg-trans-2.png")})` }}>
           
            <div className="container">
                <div className="row conntact-home">
                    <div className="col-lg-5 col-md-5 col-sm-12">
                        <div className="contact-home1-left bg-secondry">
                            <div className="contact-tag-line bg-white site-text-primary">Contact us</div>
                            <div className="section-content p-lr30 p-tb30">
                                <div className="call-back-form" style={{ zIndex: 1, position: 'relative' }}>
                                    <h2 className="text-white m-t0">Contact Us</h2>
                                    <form className="cons-contact-form2 form-transparent" method="post" action="form-handler2.php">
                                            <div className="form-group">
                                                <input name="username" type="text" required className="form-control" placeholder="Name" />
                                            </div>
                                            <div className="form-group">
                                                <input name="email" type="text" className="form-control" required placeholder="Email" />
                                            </div>
                                            <div className="form-group">
                                                <input name="phone" type="text" className="form-control" required placeholder="Phone" />
                                            </div>
                                            <div className="form-group">
                                                <textarea name="message" className="form-control" rows={3} placeholder="Message" defaultValue={""} />
                                            </div>
                                            <button type="submit" className="site-button ">
                                                <span className="font-weight-700 inline-block  p-lr15">Submit</span>
                                            </button>
                                        </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="section-content  contact-home1-right">
                        <div className="mt-box">
                            <div className="mt-media">
                                <FastImage src={options?.image} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}